// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowDownWhite: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="currentColor">
            <polygon
                points="802.4 1378 801 1379.375 805.2 1383.5 801 1387.625 802.4 1389 808 1383.5"
                transform="rotate(90 1095 294)"
            />
        </svg>
    );
};

export default React.memo(IconArrowDownWhite);
